// 1. Import the utilities
import { useMediaQuery } from '@chakra-ui/react';
// 2. Update the breakpoints as key-value pairs
export const breakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  '2xl': '1536px',
};


export function useDeviceMode() {
  const [isMobile, isDesktop] = useMediaQuery(['(max-width: 639px)', '(min-width: 640px)',])
  return [isMobile, isDesktop]
}
